module.exports = __webpack_public_path__ + "static/media/945VerticalLogo.cf28d0bf.svg";